module.exports = __webpack_public_path__ + "media/src/images/buttons/copy-link-5fa7900273447f42b71df18e63c72fd5.svg";